export const currencies = [
  { value: "USD", label: "United States Dollar" },
  { value: "EUR", label: "Euro" },
  { value: "GBP", label: "British Pound Sterling" },
  { value: "CAD", label: "Canadian Dollar" },
  { value: "AUD", label: "Australian Dollar" },
  { value: "JPY", label: "Japanese Yen" },
  { value: "INR", label: "Indian Rupee" },
  { value: "CNY", label: "Chinese Yuan Renminbi" },
  { value: "MXN", label: "Mexican Peso" },
  { value: "CHF", label: "Swiss Franc" },
];

export const languages = [
  { value: "en", label: "English" },
  { value: "fr", label: "French" },
];
